// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__cXB_2","col":"styles_col__kTFGj"};